import _ from 'lodash'
import {
  order_by,
  AccountRecModuleforGigProQuery,
} from '../../../graphql/__generated__/gigpro_graphql'
import {
  CrmAccountMappingsQuery,
  LoggedinUserQuery
} from '../../../graphql/__generated__/graphql'
import { AccountRecord, CrmEventRecord } from '../../../@types/module'
import { AccountFilter } from '../../../@types/common/AccountTable'

export const getAccountRecModuleData = (data: AccountRecModuleforGigProQuery) => {
  // Getting data for detail table in ICP
  const bussinessDetails: AccountRecord[] = data.accountsRec.map(e => {
    return {
      uuid: e.yelp_id as string,
      annualRevenue: e.price || 0,
      name: e.name || '',
      domain: e.website || '',
      street: e.billingstreet || '',
      city: e.billingcity || '',
      empCount: e.rating || 0,
      predictProba: e.predict_proba || 0,
      companyType: e.vertical || '', // TODO: TBC
      state: e.billingstate || '',
      country: e.billingcountry || '',
      foundingYear: e.review_count || 0,
      industry: e.first_yelp_category || '',
      specialities: e.yelp_categories || '',
    }
  })

  return { bussinessDetails, totalRecordsCount: data.totalRecords.aggregate?.count || 0 }
}

export const getCrmEventData = (
  selectedIds: any[],
  data?: AccountRecModuleforGigProQuery,
  mappings?: CrmAccountMappingsQuery,
  loggedinUser?: LoggedinUserQuery
) => {
  const accountRec: CrmEventRecord[] = []
  const fieldMappings = mappings?.crm_account_mappings
  const crmUser = loggedinUser?.user
  const selectedData = _.chain(data?.accountsRec)
    .filter(e => selectedIds.includes(e.yelp_id))
    .map(e => ({
      revtron_company_id: e.yelp_id as string,
      company: e
    }))
  .value()

  if (selectedData.length === 0 || !fieldMappings || fieldMappings.length === 0 || !crmUser) {
    return []
  }

  selectedData.forEach(d => {
    type companyKeyType = keyof typeof d.company
    const records: {[key: string]: any} = {}

    Object.keys(d.company).forEach((key) => {
      const index = fieldMappings.findIndex(m => m.revtron_field === key)
      if (index >= 0) {
        const crm_field = fieldMappings[index].crm_field
        records[crm_field] = d.company[key as companyKeyType]
      }
    })

    if (!_.isEmpty(records)) {
      accountRec.push({
        revtron_user_id: crmUser.revtron_user_id,
        revtron_company_id: d.revtron_company_id,
        crm_user_id: crmUser.crm_users?.id || null,
        records: [records],
        sobject: 'Account',
      })
    }
  })

  return accountRec
}

export const getQueryVariables = (pageNumber: number, pageSize: number, filters: AccountFilter[]) => {
  const variables = {
    where: {
      _not: { to_send_to_crm_events: {} }, website: {_is_null: false}
    } as any,
    orderBy: { "predict_proba": order_by.desc },
    limit: pageSize,
    offset: (pageNumber - 1) * pageSize,
  }
  filters.forEach((filter) => {
    if (filter.type === 'text') {
      variables.where[filter.fieldName] = {
        _ilike: `%${filter.query}%`
      }
    }
    if (filter.type === 'number') {
      const min = !!filter.min && filter.min > 0 ? filter.min : 0
      const max = !!filter.max && filter.max > 0 ? filter.max : 0
      if (min && max) {
        variables.where[filter.fieldName] = {
          _gte: min,
          _lte: max
        }
      } else if (min && !max) {
        variables.where[filter.fieldName] = {
          _gte: min,
        }
      } else if (!min && max) {
        variables.where[filter.fieldName] = {
          _lte: max
        }
      }
    }
  })

  return variables
}
